module.exports = __webpack_public_path__ + "static/media/khyatiworks.92e6cfe1.webp";